import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-plans',
  templateUrl: './plans.component.html',
  styleUrls: ['./plans.component.css']
})
export class PlansComponent {
  constructor(private router: Router) {}

  goToPlan(id: string): void {
    this.router.navigate(['/plans', id]);
  }

  getStarted(): void {
    this.router.navigate(['/auth'], { queryParams: { type: 'provider' } });
  }
}
